import React, { useEffect, useState } from "react";
import Layout from "../components/layout";
import { graphql, Link } from "gatsby";
import {
  Grid,
  Container,
  Button,
  Typography,
  Hidden,
  Zoom,
  Fade,
} from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import { StickyContainer, Sticky } from "react-sticky";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import Img from "gatsby-image";
import EventCard from "../components/events/eventCard";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { theme } from "../components/theme";
import FilterListIcon from "@material-ui/icons/FilterList";
import BackgroundImage from "gatsby-background-image";
import { Slider as SliderUI } from "@material-ui/core";
import Slider from "react-slick";
import moment from "moment";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../assets/slider.css";
import { useEventData } from "../utils/event-data";
import SlimIcon from "@material-ui/icons/ViewAgendaOutlined";
import { isFuture, parse, parseISO } from "date-fns";
import CardIcon from "@material-ui/icons/ViewArrayOutlined";
import "./css/calendar.css";
import FadeIn from "react-fade-in";
import { submitForm, getForm } from "../utils/gravityforms";

const isBrowser = typeof window !== `undefined`;

const duplicates = (arr) => {
  let seen = new Set();
  let store = new Array();
  arr.filter(
    (item) =>
      seen.size === seen.add(item).size &&
      !store.includes(item) &&
      store.push(item)
  );
  return store;
};

const useStyles = makeStyles((themes) => ({
  calendarContainer: {
    justifyContent: "flex-start",
    [themes.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  formControl: {
    width: 200,
  },
  styleFilled: {
    background: theme.palette.primary.main,
    color: "white !important",
  },
  styleOutlined: {
    background: "transparent",
    color: theme.palette.primary.main,
  },
  eventList: {
    justifyContent: "flex-start",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  calType: {
    fontSize: 30,
    marginRight: 5,
  },
}));

const settings = {
  infinite: true,
  speed: 3000,
  slidesToShow: 5,
  autoplay: true,
  arrows: true,
  autoplaySpeed: 6000,
  slidesToScroll: 2,
  initialSlide: 0,
  lazyLoad: "progressive",
  dots: false,
  className: "slider",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
        dots: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      },
    },
  ],
};
const settings2 = {
  infinite: true,
  speed: 5000,
  slidesToShow: 3,
  autoplay: true,
  autoplaySpeed: 9000,
  arrows: false,
  slidesToScroll: 1,
  initialSlide: 0,
  lazyLoad: "progressive",
  dots: false,
  className: "slider",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        dots: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      },
    },
  ],
};

const getDate = (start, end) => {
  const dateStart = moment(start, "DD/MM/YYYY"); // 1st argument - string, 2nd argument - format
  const dateEnd = moment(end, "DD/MM/YYYY"); // 1st argument - string, 2nd argument - format
  const startDate = dateStart.toDate();
  const endDate = dateEnd.toDate();
  let dateString = "";

  if (start === end) {
    dateString = startDate.toDateString();
  } else {
    dateString = startDate.toDateString() + " - " + endDate.toDateString();
  }

  return dateString;
};

const Calendar = () => {
  const theme = useTheme();
  const classes = useStyles();
  const data = useEventData();
  const [sortedCalendar, setSortedCalendar] = useState([]);
  const [calViewType, setCalViewType] = useState([true, false]);
  const [eventStyles, setEventStyles] = useState([]);
  const [eventCountries, setEventCountries] = useState([]);
  const [styleClass, setStyleClass] = useState({ 0: false });
  const [countryClass, setCountryClass] = useState({ 0: false });
  const [featured, setFeatured] = useState([]);
  const [filters, setFilters] = useState([]);
  const [filterVis, setFilterVis] = useState(true);
  const matches = useMediaQuery("(max-width:600px)");
  const [filterSticky, setFilterSticky] = useState("default");

  useEffect(() => {
    const todayDate = new Date();

    const sortedDates = data.allWpProduct.edges
      .filter((event) => {
        var dateMomentObject = moment(
          event.node.acfFields.eventStart,
          "DD/MM/YYYY"
        ); // 1st argument - string, 2nd argument - format
        var dateObject = dateMomentObject.toDate(); // convert moment.js object to Date obje
        console.log(isFuture(dateObject));
        //console.log(newDate);
        return isFuture(dateObject);
      })
      .sort(function (a, b) {
        // Turn your strings into dates, and then subtract them
        const dateA = parse(
          a.node.acfFields.eventStart.split(" ")[0],
          "dd/MM/yyyy",
          new Date()
        );
        const dateB = parse(
          b.node.acfFields.eventStart.split(" ")[0],
          "dd/MM/yyyy",
          new Date()
        );
        return dateA - dateB;
      });

    setSortedCalendar(sortedDates);
    console.log(sortedDates);
    setFeatured(
      data.allWpProduct.edges
        .filter((event) => event.node.acfFields.featured === true)
        .slice(0, 10)
    );

    const allEventStyles = data.allWpProductCategory.edges
      .filter(
        (style) =>
          style.node.name.toLowerCase() === "adventure tour" ||
          style.node.name.toLowerCase() === "day hike" ||
          style.node.name.toLowerCase() === "fusion" ||
          style.node.name.toLowerCase() === "micro tour" ||
          style.node.name.toLowerCase() === "overnight" ||
          style.node.name.toLowerCase() === "weekend escape"
      )
      .map((style) => style.node.name);
    setEventStyles(allEventStyles);

    const allEventCountries = data.allWpCountry.edges.map((country) => {
      return country.node.name;
    });
    setEventCountries(allEventCountries);

    if (isBrowser) {
      if (window.innerWidth < 600) {
        setCalViewType([false, true]);
      }
    }
  }, []);

  const addFilter = (type, value) => {
    const allEvents = data.allWpProduct.edges;
    const curCalendar = sortedCalendar;
    let newFilters = filters;
    let newCalendar = [];

    if (!newFilters.includes(value)) {
      newFilters.push(value);
    } else {
      newFilters = filters.filter((filter) => filter !== value);
    }

    setFilters(newFilters);

    newCalendar = allEvents.filter(
      (event) =>
        newFilters.includes(event.node.countries.nodes[0].name) ||
        newFilters.includes(event.node.productCategories.nodes[0].name)
    );

    if (newFilters.length < 1) {
      newCalendar = allEvents;
    }

    setSortedCalendar(
      newCalendar.sort(function (a, b) {
        // Turn your strings into dates, and then subtract them
        const dateA = parse(
          a.node.acfFields.eventStart.split(" ")[0],
          "dd/MM/yyyy",
          new Date()
        );
        const dateB = parse(
          b.node.acfFields.eventStart.split(" ")[0],
          "dd/MM/yyyy",
          new Date()
        );
        return dateA - dateB;
      })
    );
  };

  const handleStyleSelect = (index) => {
    styleClass[index] = !styleClass[index];
  };
  const handleCountrySelect = (index) => {
    countryClass[index] = !countryClass[index];
  };

  const caltypeactive = {
    color: "red",
    cursor: "pointer",
  };

  const caltypeinactive = {
    color: "Black",
    cursor: "pointer",
  };

  const changeCalType = (index) => {
    if (index === 1) {
      setCalViewType([true, false]);
    } else {
      setCalViewType([false, true]);
    }
  };

  const handleFilterVis = () => {
    setFilterVis(!filterVis);
  };

  return (
    <Layout>
      {/* Hero */}
      {/* Popular Countries */}
      <Grid container style={{ marginTop: 30 }}>
        <Container>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="h2">Where we go</Typography>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container style={{ marginTop: 20 }}>
        <Slider {...settings}>
          {data.allWpCountry.edges.map((country) => {
            return (
              <Link
                to={`/${country.node.name.toLowerCase().replace(" ", "-")}`}
                key={country.node.name}
              >
                <div
                  style={{
                    height: 130,
                    width: "100%",
                    borderRadius: 8,
                  }}
                >
                  <BackgroundImage
                    fluid={
                      country.node.acfFields.featuredImage.localFile
                        .childImageSharp.fluid
                    }
                    style={{
                      height: 130,
                      overflow: "hidden",
                      borderRadius: 12,
                      width: "100%",
                    }}
                    Tag="div"
                  >
                    <div
                      style={{
                        height: 130,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignContent: "center",
                        backgroundColor: "rgba(0,0,0,0.2)",
                      }}
                    >
                      <Typography
                        variant="h2"
                        style={{
                          color: "white",

                          textAlign: "center",
                        }}
                      >
                        {country.node.name}
                      </Typography>
                    </div>
                  </BackgroundImage>
                </div>
              </Link>
            );
          })}
        </Slider>
      </Container>

      {/* Why not try? */}
      <Grid container style={{ marginTop: 30 }}>
        <Container>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="h2">Featured Trips</Typography>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container style={{ marginTop: 20 }}>
        <Slider {...settings2}>
          {featured.map((event) => {
            if (event.node.acfFields.featured) {
              return (
                <Link
                  to={`/event/${event.node.locations.nodes[0].slug}`}
                  key={event.node.id}
                >
                  <div
                    style={{
                      height: 200,
                      width: "100%",
                    }}
                  >
                    <BackgroundImage
                      fluid={
                        event.node.featuredImage.node.localFile.childImageSharp
                          .fluid
                      }
                      style={{
                        height: 200,
                        width: "100%",
                        overflow: "hidden",
                        borderRadius: 8,
                      }}
                      Tag="div"
                    >
                      <div
                        style={{
                          color: "white",
                          width: "100%",
                          height: "200px",
                          backgroundColor: "rgba(0,0,0,0.3)",
                          display: "flex",
                          flexDirection: "column",
                          textAlign: "center",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="h5" style={{ fontWeight: 600 }}>
                          {event.node.title.split(":")[0]}
                        </Typography>
                        <Typography variant="h6" style={{ fontWeight: 600 }}>
                          {" "}
                          {getDate(
                            event.node.acfFields.eventStart,
                            event.node.acfFields.eventEnd
                          )}
                        </Typography>
                      </div>
                    </BackgroundImage>
                  </div>
                </Link>
              );
            } else {
              return false;
            }
          })}
        </Slider>
      </Container>
      {/* Calendar */}
      <Grid container style={{ marginTop: 50, paddingBottom: 70 }}>
        <Container>
          <Grid
            container
            className={classes.calendarContainer}
            alignItems="flex-start"
          >
            <Grid
              item
              container
              xs={12}
              sm={12}
              md={!filterVis ? 12 : 9}
              className={classes.eventList}
            >
              {/* Title */}
              <Grid item container xs={12} spacing={2} alignItems="center">
                <Grid item xs={6}>
                  <Typography variant="h2">Calendar</Typography>
                </Grid>
                <Grid
                  item
                  container
                  alignItems="center"
                  xs={6}
                  justify="flex-end"
                >
                  <CardIcon
                    className={classes.calType}
                    style={calViewType[0] ? caltypeactive : caltypeinactive}
                    onClick={() => changeCalType(1)}
                  />
                  <SlimIcon
                    className={classes.calType2}
                    onClick={() => changeCalType(0)}
                    style={calViewType[1] ? caltypeactive : caltypeinactive}
                  />
                  <Hidden smDown>
                    <FilterListIcon
                      className={classes.calType}
                      style={
                        filterVis
                          ? {
                              color: theme.palette.secondary.main,
                              marginLeft: 5,
                            }
                          : { color: "black", marginLeft: 5 }
                      }
                      onClick={handleFilterVis}
                    />
                  </Hidden>
                </Grid>
              </Grid>
              {/* List */}
              <Grid
                item
                container
                xs={12}
                sm={12}
                md={12}
                style={{ marginTop: 10 }}
                spacing={2}
                justify="flex-start"
              >
                {sortedCalendar.map((event, index) => {
                  return (
                    <Grid
                      item
                      xs={12}
                      sm={calViewType[0] ? 6 : 12}
                      md={calViewType[0] ? (!filterVis ? 3 : 4) : 12}
                      style={
                        calViewType[0]
                          ? { marginBottom: 20 }
                          : { marginBottom: 5 }
                      }
                      key={event.node.id}
                    >
                      <FadeIn
                        key={event.node.id}
                        delay={150 * index}
                        transitionDuration={200}
                      >
                        <EventCard
                          img={
                            event.node.featuredImage.node.localFile
                              .childImageSharp.fluid
                          }
                          calViewType={calViewType}
                          continent={event.node.countries.nodes[0].name}
                          title={event.node.title.split(":")[0]}
                          startDate={event.node.acfFields.eventStart}
                          endDate={event.node.acfFields.eventEnd}
                          price={event.node.price}
                          days={event.node.acfFields.days}
                          grade={event.node.acfFields.grade}
                          distance={event.node.acfFields.distance}
                          slug={event.node.locations.nodes[0].slug}
                          days="7 days"
                          category={event.node.productCategories.nodes[0].name}
                        ></EventCard>
                      </FadeIn>
                    </Grid>
                  );
                })}
                {sortedCalendar.length < 1 && (
                  <Grid item xs={12}>
                    <Typography variant={"h6"}>
                      No events found. Try adjusting your filters
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
            {/* Filter */}

            <Hidden smDown>
              {filterVis && (
                <Grid
                  item
                  container
                  xs={12}
                  md={3}
                  alignItems="flex-start"
                  justify="flex-end"
                >
                  <Grid
                    item
                    container
                    id="style-2"
                    justify="flex-end"
                    xs={12}
                    alignItems="flex-start"
                    style={{
                      overflowY: "scroll",
                      width: "100%",
                      right: "500px",
                      height: "auto",
                      maxHeight: "85vh",
                      boxShadow: "0 3px 8px 2px rgba(0,0,0,0.08)",
                      background: "white",
                      borderRadius: 8,
                      padding: "20px 10px",
                    }}
                  >
                    <Grid item container xs={12} style={{ paddingLeft: 10 }}>
                      <Grid item container xs={10}>
                        <Typography variant="h5" style={{ fontWeight: 600 }}>
                          Find your adventure
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        container
                        alignItems="center"
                        xs={2}
                        onClick={handleFilterVis}
                        style={{ cursor: "pointer" }}
                      >
                        <HighlightOffIcon />
                      </Grid>

                      <Grid item container xs={12}>
                        <Typography
                          variant="body1"
                          style={{
                            marginTop: 20,
                          }}
                        >
                          Where would you like to go?
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        container
                        spacing={1}
                        xs={12}
                        style={{ marginTop: 15 }}
                      >
                        {eventCountries.map((country, index) => {
                          return (
                            <Grid item xs={6} key={country}>
                              <Button
                                variant="outlined"
                                style={{
                                  borderRadius: 2,
                                  color: theme.palette.secondary.main,
                                  fontSize: 12,
                                  borderColor: theme.palette.secondary.main,
                                }}
                                onClick={() => {
                                  addFilter("country", country);
                                  handleCountrySelect(index);
                                }}
                                className={
                                  countryClass[index]
                                    ? classes.styleFilled
                                    : classes.styleOutlined
                                }
                              >
                                {country}
                              </Button>
                            </Grid>
                          );
                        })}
                      </Grid>
                      <Grid item container xs={12}>
                        <Typography
                          variant="body1"
                          style={{
                            marginTop: 20,
                          }}
                        >
                          What's your hiking style?
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        container
                        spacing={1}
                        xs={12}
                        style={{ marginTop: 15 }}
                      >
                        {eventStyles.map((style, index) => {
                          return (
                            <Button
                              variant="outlined"
                              style={{
                                borderRadius: 2,
                                color: theme.palette.secondary.main,
                                borderColor: theme.palette.secondary.main,
                                fontSize: 12,
                                width: "auto",
                                padding: "5px 15px",
                                margin: "5px",
                              }}
                              onClick={() => {
                                addFilter("style", style);
                                handleStyleSelect(index);
                              }}
                              className={
                                styleClass[index]
                                  ? classes.styleFilled
                                  : classes.styleOutlined
                              }
                            >
                              {style}
                            </Button>
                          );
                        })}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Hidden>
          </Grid>
        </Container>
      </Grid>
    </Layout>
  );
};
export default Calendar;
